import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../app";
import { Cart } from "../app-cart";
import * as m from "./models/register-models";
import { ChooseLocations } from "./models/choose-locations";
import { ChooseSkillLevels } from "./models/choose-skill-levels";
import { ChooseAllocations } from "./models/choose-allocations";

const divRoot: Element = document.getElementsByClassName("register-form")[0];
const divModel: HTMLDivElement = document.querySelector("#divRegisterCampModel");

export class Next {

    enabled: ko.PureComputed<boolean>;
    enableBack: ko.PureComputed<boolean>;
    visible: ko.PureComputed<boolean>;

    back: () => void;
    next: () => void;

    constructor(root: ViewModel) {
        let self = this;

        self.enabled = ko.pureComputed(() => {
            return root.activeForm().next().enabled();
        }, self);

        self.enableBack = ko.pureComputed(() => {
            return !root.activeForm().equals(root.chooseLocations());
        }, self);

        self.visible = ko.pureComputed(() => {
            return root.activeForm().equals(root.chooseLocations()) ? self.enabled() : true;
        }, self);

        self.back = () => {
            if (!self.enableBack()) { return; }
            root.activeForm().back();
        }

        self.next = () => {
            if (!self.enabled()) { return; }
            root.activeForm().next().next();
        }
    }
}



export class ViewModel {
    cart: Cart;
    activities: m.Activity[];
    programs: m.Program[];

    activeForm = ko.observable<m.Form>();
    filledSummary = ko.observable<m.FilledSummary>();
    next = ko.observable<Next>();
    waitList = ko.observable<m.WaitList>();

    chooseLocations = ko.observable<ChooseLocations>();
    chooseSkillLevels = ko.observable<ChooseSkillLevels>();
    chooseAllocations = ko.observable<ChooseAllocations>();

    selectedActivities = ko.observableArray<m.Activity>();
    selectedLocations = ko.observableArray<m.Location>();
    selectedSkillLevels = ko.observableArray<m.SkillLevel>();
    selectedAllocations: ko.PureComputed<m.Allocation[]>;

    currency: ko.Computed<string>;
    heading: ko.PureComputed<string>;
    showRefresh: ko.PureComputed<boolean>;
    springBreak: ko.PureComputed<boolean>;
    validRegion: ko.Computed<boolean>;

    allForms: ko.PureComputed<m.Form[]>;
    filled: ko.PureComputed<m.Form[]>;
    unFilled: ko.PureComputed<m.Form[]>;

    filterActivities: (programs: number[]) => m.Activity[];

    programsHtml: (programs: number[]) => string;
    programsText: (programs: number[]) => string;
    showWaitList: (allocation: m.Allocation) => void;

    constructor(model: any) {
        let self = this;

        var data = JSON.parse(model);

        self.cart = data.cart != null ? new Cart(data.cart, data.returnUrl) : null;

        self.activities = _(data.activities).map(x => new m.Activity(x, self));

        var temp: m.Program[] = [];
        _(self.activities).each(x => _(x.programs).each(y => temp.push(new m.Program(y))));
        self.programs = _(temp).sortBy(x => x.sort);

        self.filledSummary(new m.FilledSummary(self));
        self.next(new Next(self));

        self.chooseLocations(new ChooseLocations(data, self));
        self.chooseSkillLevels(new ChooseSkillLevels(self));
        self.chooseAllocations(new ChooseAllocations(self));

        self.allForms = ko.pureComputed(() => {
            return [
                self.chooseLocations(),
                self.chooseSkillLevels(),
                self.chooseAllocations()
            ];
        }, self);

        self.filled = ko.pureComputed(() => {
            return _.first(self.allForms(), 2);
        }, self);

        self.unFilled = ko.pureComputed(() => {
            return _.last(self.allForms(), 2);
        }, self);

        self.heading = ko.pureComputed(() => {
            return self.activeForm() ?
                self.activeForm().heading :
                "Choose...";
        }, self);

        self.selectedAllocations = ko.pureComputed(() => {
            return _(self.chooseAllocations().allocations()).filter(x => x.qty() > 0);
        }, self);

        self.currency = ko.computed(() => {
            if (!_(self.selectedLocations()).any()) { return "CAD"; }
            return _.chain(self.selectedLocations())
                .map(x => x.region.currency)
                .first()
                .value();
        }, self);

        self.showRefresh = ko.pureComputed(() => {
            return self.activeForm().equals(self.chooseAllocations());
        }, self);

        self.springBreak = ko.pureComputed(() => {
            return self.activeForm().equals(self.chooseLocations()) && self.chooseLocations().springBreak();
        }, self);

        self.validRegion = ko.computed(() => {
            if (self.cart == null) { return true; }
            return _(self.selectedLocations()).all(x => x.region.id == self.cart.region.id);
        }, self);

        self.activeForm.subscribe(newVal => {
            newVal.next.valueHasMutated();
            App.scrollTop(300);
        });

        self.selectedActivities.subscribe(() => {
            self.chooseSkillLevels().skillLevels.removeAll();
        });

        self.selectedLocations.subscribe(() => {
            self.chooseSkillLevels().skillLevels.removeAll();
        });

        self.selectedSkillLevels.subscribe(() => {
            self.chooseAllocations().allocations.removeAll();
        });

        self.validRegion.subscribe(newVal => {
            if (!newVal) {
                // TODO: localized api message
                var msg = "Order now limited to camps in " + self.cart.region.name;
                App.alertError(msg);
            }
        });

        self.waitList.subscribe(newVal => {
            $("#waitListModal").modal(newVal ? "show" : "hide");
        });

        self.filterActivities = (programs: number[]) => {
            let temp = _(self.activities).filter(x => _(x.programs).any(y => _(programs).contains(y.id)));
            return _(temp).sortBy(x => x.id);
        }

        self.programsHtml = (programs: number[]) => {
            return _.chain(self.programs)
                .filter(x => _(programs).contains(x.id))
                .sortBy(x => x.sort)
                .map(x => "<span class='aspect-name " + x.textCss + "'>" + x.name + "</span>")
                .value()
                .join(", ");
        }

        self.programsText = (programs: number[]) => {
            return _.chain(self.programs)
                .filter(x => _(programs).contains(x.id))
                .sortBy(x => x.sort)
                .map(x => x.name)
                .value()
                .join(", ");
        }

        self.showWaitList = (allocation: m.Allocation) => {
            self.waitList(new m.WaitList(allocation, self));
        }

        self.chooseLocations().show();

        //App.alertInfo("Welcome to the Camp search page");

        _.delay(() => {
            App.scrollTop(500);
        }, 500);

        // TODO: enable this for production
        // back or refresh
        //window.addEventListener("beforeunload", e => {
        //    if (!_(self.selectedLocations()).any()) { return true; }

        //    // cancel the event
        //    e.preventDefault();

        //    // Chrome requires returnValue to be set
        //    e.returnValue = '';
        //});
    }

    public getProgram(id: any): m.Program {
        let self = this;
        return self.programs.find(x => x.id == +id);
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(divModel.textContent), divRoot);
    }
}

$(document).ready(() => init());